<template>
  <div class="measurement-widget" v-if="showMeasuringTool">
    <div class="measurement-header">
      <fa :icon="['fas', 'ruler']" class="measurement-header-icon" size="sm" />
      <span class="measurement-header-label">Measurement</span>
    </div>
    <div class="measurement-body">
      <div class="measurement-row">
        <span class="measurement-key">Length</span>
        <span class="measurement-val">{{ measurement[0] }} {{ measurement[1] }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.measurement-widget {
  width: 12.5rem;
  background: #063c6d;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 5px;
  overflow: hidden;
  font-family: system-ui, -apple-system, sans-serif;
  color: #fff;
}

.measurement-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  background: rgba(255, 255, 255, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.measurement-header-icon {
  color: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
}

.measurement-header-label {
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.measurement-body {
  padding: 0.375rem 0.875rem;
}

.measurement-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.measurement-key {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.measurement-val {
  color: #fff;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>

<script>
export default {
    name: 'Generic_Measurement',
    props: ['showMeasuringTool', 'measurement'],
}
</script>
